import { Component, OnInit, Input } from '@angular/core';
import { InfiniteScrollableComponent } from '../infinite-scrollable/infinite-scrollable.component';
import { Stream } from 'src/models/stream';
import { ActivatedRoute } from '@angular/router';
import { ListStreamsI } from './list-streams-i';

@Component({
  selector: 'app-list-streams',
  templateUrl: './list-streams.component.html',
  styleUrls: ['./list-streams.component.scss']
})
export class ListStreamsComponent extends InfiniteScrollableComponent implements OnInit {

  @Input() listStreamsImpl: ListStreamsI;

  @Input() itemsPerPage = 42;

  @Input() showListenNotesLogo = false;

  public streams = new Array<Stream>();

  public scrollControlEnabled = false;

  constructor(
    private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
        this.streams = new Array<Stream>();
        this.start = 0;

        this.loadStreams();
    });
  }

  protected getItemsPerPage(): number {
    return this.itemsPerPage;
  }

  protected loadStreams() {
    this.scrollControlEnabled = false;

    this.listStreamsImpl.getStreamsObservable(this.start, this.itemsPerPage).subscribe((value: Stream[]) => {
      value.forEach((stream: Stream) => this.streams.push(stream));

      if (value.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }
    });
  }

}